const actions = {
  CREATE_VOUCHER_BOX: 'CREATE_VOUCHER_BOX',
  CREATE_VOUCHER_BOX_ENDED: 'CREATE_VOUCHER_BOX_ENDED',
  SEARCH_VOUCHER_BOXES: 'SEARCH_VOUCHER_BOXES',
  SEARCH_VOUCHER_BOXES_ENDED: 'SEARCH_VOUCHER_BOXES_ENDED',
  UPDATE_VOUCHER_BOX: 'UPDATE_VOUCHER_BOX',
  UPDATE_VOUCHER_BOX_ENDED: 'UPDATE_VOUCHER_BOX_ENDED',
  DELETE_VOUCHER_BOXES: 'DELETE_VOUCHER_BOXES',
  DELETE_VOUCHER_BOXES_ENDED: 'DELETE_VOUCHER_BOXES_ENDED',
};

export default actions;
